import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssignmentInd = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8C13.3833 8 14.5 9.11667 14.5 10.5C14.5 11.8833 13.3833 13 12 13C10.6167 13 9.5 11.8833 9.5 10.5C9.5 9.11667 10.6167 8 12 8Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 16.8333V18H7V16.8333C7 15.1667 10.3333 14.25 12 14.25C13.6667 14.25 17 15.1667 17 16.8333Z",
			fill: "#111827"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.71435 1.90648L7.63953 3.25H6C4.48079 3.25 3.25 4.48079 3.25 6V19C3.25 20.5192 4.48079 21.75 6 21.75H18C19.5192 21.75 20.75 20.5192 20.75 19V6C20.75 4.48079 19.5192 3.25 18 3.25H16.3606L15.2868 1.9067L15.2862 1.90588C14.954 1.49157 14.4519 1.25 13.92 1.25H10.081C9.54912 1.25 9.0465 1.49217 8.71435 1.90648ZM9.88535 2.8439C9.9332 2.78435 10.005 2.75 10.081 2.75H13.92C13.996 2.75 14.0677 2.78432 14.1156 2.84383L15.25 4.26293V5C15.25 5.13779 15.1378 5.25 15 5.25H9C8.86221 5.25 8.75 5.13779 8.75 5V4.26309L9.88535 2.8439ZM16.75 5V4.75H18C18.6908 4.75 19.25 5.30921 19.25 6V19C19.25 19.6908 18.6908 20.25 18 20.25H6C5.30921 20.25 4.75 19.6908 4.75 19V6C4.75 5.30921 5.30921 4.75 6 4.75H7.25V5C7.25 5.96621 8.03379 6.75 9 6.75H15C15.9662 6.75 16.75 5.96621 16.75 5Z",
			fill: "#111827"
		})
	]
});
const ForwardRef = forwardRef(SvgAssignmentInd);
export default ForwardRef;
